var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Injector } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { forkJoin } from 'rxjs';
import { ProductFactory } from '@app/shared/FactoryResources/ProductFactory/IIncompleteProduct';
import { AppConsts } from '@shared/AppConsts';
import * as moment from 'moment';
import { PersonEducation } from '../../../../../shared/AppEnums';
import { finalize } from 'rxjs/operators';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
var MyNeedsCalculatorService = /** @class */ (function () {
    function MyNeedsCalculatorService(http, injector) {
        this.http = http;
        this.injector = injector;
        this._questionaireUrl = '/assets/data/questionaire.json';
        this._occupationUrl = '/assets/data/occupation.json';
        this._insuranceUrl = '/assets/data/InsuranceMedicalAidSchemes.json';
        this.vm = {};
        //error on unitrate was assigned this.unitRate
        this.cachedData = {
            unitRate: 0,
            // tslint:disable-next-line: no-use-before-declare
            finalData: new FinalData(),
            // tslint:disable-next-line: no-use-before-declare
            calculatedData: new CalculatedData(),
            // tslint:disable-next-line: no-use-before-declare
            answerSections: new AnsweredSections()
        };
        this.extQuoteResponses = [];
        this.getProductConfig();
    }
    MyNeedsCalculatorService.prototype.getUnitRateAsync = function () {
        return __awaiter(this, void 0, void 0, function () {
            var productUID, productFactory, self, benefitPatternSetPromise, premiumPatternSetPromise, product, unitRate;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        productUID = '8a17c46f-cbc5-4352-8930-aebae605cfe9';
                        return [4 /*yield*/, new ProductFactory(this.injector)
                                .withMetadataAsync(abp.setting.values[AppConsts.KeyVaultSecrets.ActiveGenerationName])];
                    case 1:
                        productFactory = _a.sent();
                        self = this;
                        benefitPatternSetPromise = productFactory.forProduct(productUID)
                            .extractBenefitPatternSetAsync();
                        premiumPatternSetPromise = productFactory.forProduct(productUID)
                            .extractPremiumPatternSetAsync();
                        return [4 /*yield*/, Promise.all([benefitPatternSetPromise, premiumPatternSetPromise])];
                    case 2:
                        _a.sent();
                        product = productFactory.build();
                        unitRate = product.RateTable.reduce(function (max, item) { return (item.BaseRate > max ? item.BaseRate : max); }, product.RateTable[0].UnitRate);
                        self.cachedData.unitRate = unitRate;
                        return [2 /*return*/];
                }
            });
        });
    };
    MyNeedsCalculatorService.prototype.getQuestionaireData = function () {
        return this.http.get(this._questionaireUrl);
    };
    MyNeedsCalculatorService.prototype.getOccupationList = function () {
        return this.http.get(this._occupationUrl);
    };
    MyNeedsCalculatorService.prototype.getMedicalAidSchemesList = function () {
        return this.http.get(this._insuranceUrl);
    };
    MyNeedsCalculatorService.prototype.getFamilyStepper = function () {
        if (this.cachedData) {
            if (this.cachedData.answerSections) {
                return this.cachedData.answerSections.familySectionAnswers;
            }
        }
    };
    MyNeedsCalculatorService.prototype.getEarningStepper = function () {
        if (this.cachedData) {
            if (this.cachedData.answerSections) {
                return this.cachedData.answerSections.earningSectionAnswers;
            }
        }
    };
    MyNeedsCalculatorService.prototype.getAge = function () {
        try {
            if (this.getFamilyStepper()) {
                var getFamilyStepper = this.getFamilyStepper();
                var age = getFamilyStepper.familyAnswers.value.find(function (x) { return x.label === 'I was born on'; });
                if (age) {
                    return moment(age.value).format('yyyy-MM-DD').getAgeFromDate();
                }
            }
        }
        catch (e) {
            return 18;
        }
    };
    MyNeedsCalculatorService.prototype.getGender = function () {
        try {
            if (this.getFamilyStepper()) {
                var getFamilyStepper = this.getFamilyStepper();
                var gender = getFamilyStepper.familyAnswers.value[0].genderSection;
                if (gender) {
                    return gender.value.maleStringToInt();
                }
            }
        }
        catch (e) {
            return 0;
        }
    };
    MyNeedsCalculatorService.prototype.getGrossIncome = function () {
        try {
            if (this.getEarningStepper) {
                var getEarningStepper = this.getEarningStepper().find(function (x) { return x.question === 'How much do you earn?'; });
                if (getEarningStepper) {
                    return getEarningStepper.answers[0].value[0].value;
                }
            }
        }
        catch (e) {
            return 10000;
        }
    };
    MyNeedsCalculatorService.prototype.gethouseHoldIncome = function () {
        return undefined;
    };
    MyNeedsCalculatorService.prototype.getOccupations = function () {
        if (this.getEarningStepper) {
            var getEarningStepper = this.getEarningStepper().find(function (x) { return x.question === 'What is your occupation?'; });
            if (getEarningStepper) {
                return getEarningStepper.answers[0].value[0].value;
            }
        }
        return null;
    };
    MyNeedsCalculatorService.prototype.getEducation = function () {
        var dropdownItems = [
            {
                name: AppConsts.QuoteEducation.Nomatric,
                value: PersonEducation.NoMatric
            },
            {
                name: AppConsts.QuoteEducation.Matric,
                value: PersonEducation.Matric
            }, {
                name: AppConsts.QuoteEducation.Diplomalessthan,
                value: PersonEducation.DiplomaLessThanFourYears
            }, {
                name: AppConsts.QuoteEducation.Diplomaequalorgreater,
                value: PersonEducation.DiplomaFourYearsOrMoreThan
            }, {
                name: AppConsts.QuoteEducation.University,
                value: PersonEducation.ThreeYearsUniversityUnderGraduateDegree
            }, {
                name: AppConsts.QuoteEducation.University4Years,
                value: PersonEducation.FourYearsUniversityUnderGraduateDegree
            }, {
                name: AppConsts.QuoteEducation.Postgraduate,
                value: PersonEducation.PostGraduateStudy
            }
        ];
        try {
            if (this.getEarningStepper) {
                var getEarningStepper_1 = this.getEarningStepper().find(function (x) { return x.question === 'What is your education level?'; });
                if (getEarningStepper_1) {
                    return dropdownItems.find(function (x) { return x.name === getEarningStepper_1.answers[0].value[0].value; }).value;
                }
            }
        }
        catch (e) {
            return 0;
        }
        return undefined;
    };
    MyNeedsCalculatorService.prototype.getSmoker = function () {
        return 0;
    };
    MyNeedsCalculatorService.prototype.getSumAssured = function (productName) {
        if (productName === AppConsts.configProducts.Disability) {
            return this.cachedData.finalData.DisabilityLumpsumAmount;
        }
        if (productName === AppConsts.configProducts.Life) {
            return this.cachedData.finalData.lifeInsuranceLumpsumAmount;
        }
        if (productName === AppConsts.configProducts.SevereIllness) {
            return this.cachedData.finalData.SevereIllnessLumpsumAmount;
        }
        return 100000;
    };
    MyNeedsCalculatorService.prototype.getProductConfig = function () {
        var _this = this;
        var url = abp.setting.values[AppConsts.KeyVaultSecrets.AppConfigAngularProductConfigUrl];
        this.http.get(url).subscribe(function (res) {
            _this.productConfig = res;
            if (res) {
                _this.defaultProduct = res.find(function (x) { return x.IsDefault; });
            }
        });
    };
    MyNeedsCalculatorService.prototype.createExtQuoteForAllProduct = function (callback) {
        var _this = this;
        this.extQuoteResponses = [];
        var observerArray = [];
        this.productConfig.forEach(function (element) {
            observerArray.push(_this.createExtQuote(element));
        });
        forkJoin(observerArray)
            .subscribe(function (res) {
            _this.extQuoteResponses = _this.extQuoteResponses.concat(res);
            callback();
            abp.ui.clearBusy();
        }, function (err) {
        });
    };
    MyNeedsCalculatorService.prototype.createExtQuote = function (defaultProduct) {
        if (!this.productConfig) {
            return;
        }
        if (!defaultProduct) {
            return;
        }
        var extQuoteeBody = {
            productFriendlyName: defaultProduct.FriendlyName,
            productUid: defaultProduct.UID,
            ratingFactor: {
                age: this.getAge(),
                education: this.getEducation(),
                gender: this.getGender(),
                income: this.getGrossIncome(),
                smokingStatus: this.getSmoker()
            },
            sumAssuredAmount: this.getSumAssured(defaultProduct.FriendlyName),
            vendorId: abp.setting.values[AppConsts.KeyVaultSecrets.MicroServicesExtQuoteVendorId],
            additionalInformation: {
                hivStatus: '',
                majorConditions: '',
                prescribedMedication: '',
                treatmentLastFourMonths: '',
                upcomingTreatment: ''
            }
        };
        abp.ui.setBusy();
        var url = abp.setting.values[AppConsts.KeyVaultSecrets.MicroServicesExtQuote] + AppConsts.Endpoints.CreateExtQuoteDetails;
        var headers = new HttpHeaders({
            'Ocp-Apim-Subscription-Key': abp.setting.values[AppConsts.KeyVaultSecrets.MicroServicesExtQuoteOcpApimSubscriptionKey],
            'Content-Type': 'application/json'
        });
        return this.http.post(url, extQuoteeBody, { headers: headers });
    };
    MyNeedsCalculatorService.prototype.getPremiumByProduct = function () {
    };
    MyNeedsCalculatorService.prototype.sendQuote = function (body) {
        abp.ui.setBusy();
        var url = abp.setting.values[AppConsts.KeyVaultSecrets.PortalSettingsauthority] + AppConsts.Endpoints.sendQuote;
        var headers = new HttpHeaders({
            'Content-Type': 'application/json'
        });
        return this.http.post(url, body, { headers: headers }).pipe(finalize(function () {
            abp.ui.clearBusy();
        })).subscribe(function (res) {
            abp.notify.success('Sent');
        });
    };
    MyNeedsCalculatorService.ngInjectableDef = i0.defineInjectable({ factory: function MyNeedsCalculatorService_Factory() { return new MyNeedsCalculatorService(i0.inject(i1.HttpClient), i0.inject(i0.INJECTOR)); }, token: MyNeedsCalculatorService, providedIn: "root" });
    return MyNeedsCalculatorService;
}());
export { MyNeedsCalculatorService };
var CalculatedData = /** @class */ (function () {
    function CalculatedData() {
    }
    return CalculatedData;
}());
var FinalData = /** @class */ (function () {
    function FinalData() {
    }
    return FinalData;
}());
var FamilyStepperData = /** @class */ (function () {
    function FamilyStepperData() {
    }
    return FamilyStepperData;
}());
var HomeStepperData = /** @class */ (function () {
    function HomeStepperData() {
    }
    return HomeStepperData;
}());
var InsuranceStepperData = /** @class */ (function () {
    function InsuranceStepperData() {
    }
    return InsuranceStepperData;
}());
var AnsweredSections = /** @class */ (function () {
    function AnsweredSections() {
        this.familySectionAnswers = new FamilyStepperData();
        this.homeSectionAnswers = new HomeStepperData();
        this.insuranceSectionAnswers = new InsuranceStepperData();
        this.tempEmploymentInsuranceList = new Array();
        this.tempPurchasedInsuranceList = new Array();
        this.selectedPurchasedInsuranceList = new Array();
        this.selectedEmploymentInsuranceList = new Array();
    }
    return AnsweredSections;
}());
